import { motion, AnimatePresence } from "framer-motion";
import { TRANSITION_DURATION } from "../constants";

const transition = {
  duration: TRANSITION_DURATION / 1000,
};

const variants = {
  show: {
    opacity: 1,
    transition,
  },
  hide: {
    opacity: 0,
    transition,
  },
};

const Transition = ({ show, color, children }) => {
  return (
    <AnimatePresence initial={false}>
      {show && (
        <motion.div
          variants={variants}
          initial="hide"
          animate="show"
          exit="hide"
          className={`transition-screen ${color}`}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Transition;
